<template>
    <div class="mt-4">
        <div class="columns">
            <!--
                EXPLICAÇÃO SOBRE OS $emit('update:xxx')
                TEM RELAÇÃO COM O .sync NO COMPONENTE PAI
                https://br.vuejs.org/v2/guide/components-custom-events.html#Modificador-sync
            -->
            <div class="column is-two-thirds">
                <v-input
                    ref="descricaoInput"
                    title="descricao"
                    :value="descricao"
                    :invalid="!descricao"
                    :disabled="disabled"
                    @input="$emit('update:descricao', $event.trim().toLocaleUpperCase())"
                    required
                />
            </div>
            <div class="column is-one-third">
                <vss-select
                    ref="colaboradorSelect"
                    label="nome"
                    :title="'colaborador'"
                    :value="usuario"
                    :loading="colaboradoresLoading"
                    :options="colaboradores"
                    :invalid="!usuario"
                    :disabled="disabled || !!id"
                    @input="$emit('update:usuario', $event)"
                    @search="searchColaborador"
                    searchable
                    required
                />
            </div>
        </div>

        <div class="columns">
            <div class="column is-one-third">
                <verified-date-picker
                    title="data-inicio"
                    v-model="innerDataInicio"
                    :years-range="[0, 3]"
                    :subtractDateByDate="$moment().add(1, 'days').toDate()"
                    :addDateYears="2"
                    :inForm="true"
                    :disabled="disabled"
                    @input="handleDateChange"
                    :showClean="false"
                    :showToday="false"
                />
            </div>
            <div class="column is-one-third">
                <vss-select
                    title="tipo-frequencia"
                    :value="tipos.find(e => e.value == tipoFrequencia)"
                    :options="tipos"
                    :disabled="disabled"
                    @input="handleTipoFrequenciaChange"
                    ml-labels
                />
            </div>
            <div class="column is-one-third">
                <v-input
                    v-if="tipoFrequencia == 1"
                    type="tel"
                    validchars="0123456789"
                    title="qtde-dias"
                    :value="frequencia"
                    :disabled="disabled"
                    @input="$emit('update:frequencia', validateNumber($event))"
                />
                <vss-select
                    v-if="tipoFrequencia == 2"
                    ref="diaSemanaSelect"
                    title="dias-da-semana"
                    msg="msg-selecione-um-dia-da-semana"
                    :value="diasSemana.filter(e => frequencia.split(',').includes(e.value))"
                    :options="diasSemana"
                    :close-on-select="false"
                    :invalid="!frequencia"
                    :disabled="disabled"
                    @input="handleDiasSemanaChange"
                    multiple ml-labels
                />
            </div>
        </div>

        <div class="columns">
            <div class="column is-one-third">
                <vss-select
                    title="obriga-sequencia"
                    :value="opcoesSequencia.find(e => e.value == obrigaSequencia)"
                    :options="opcoesSequencia"
                    :disabled="disabled"
                    @input="$emit('update:obriga-sequencia', $event.value)"
                    ml-labels
                />
            </div>
            <div class="column is-one-third">
                <vss-select
                    title="permite-avulso"
                    :value="opcoesAvulso.find(e => e.value == permiteAvulso)"
                    :options="opcoesAvulso"
                    :disabled="disabled"
                    @input="$emit('update:permite-avulso', $event.value)"
                    ml-labels
                />
            </div>
            <div class="column is-one-third">
                <vss-select
                    title="situacao"
                    :value="situacoes.find(e => e.value == situacao)"
                    :options="situacoes"
                    :disabled="disabled"
                    @input="$emit('update:situacao', $event.value)"
                    ml-labels
                />
            </div>
        </div>
    </div>
</template>

<script>
import ColaboradorService from "@/services/ColaboradorService";

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        descricao: {
            type: String,
            default: ''
        },
        usuario: {
            type: Object,
            default: () => null
        },
        situacao: {
            type: Number,
            default: 0
        },
        tipoFrequencia: {
            type: Number,
            default: 1
        },
        frequencia: {
            type: String,
            default: '7'
        },
        obrigaSequencia: {
            type: Number,
            default: 0
        },
        permiteAvulso: {
            type: Number,
            default: 0
        },
        datainicio: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            id: this.$route.params.id,
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            colaboradoresLoading: false,
            colaboradores: [],
            modalIni: false,
            ini: new Date(),
            situacoes: [
                {value: 1, label: 'ativo'},
                {value: 0, label: 'inativo'},
            ],
            tipos: [
                {value: 1, label: 'qtde-dias'},
                {value: 2, label: 'dias-semana'}
            ],
            diasSemana: [
                {value: '1', label: 'domingo'},
                {value: '2', label: 'segunda'},
                {value: '3', label: 'terca'  },
                {value: '4', label: 'quarta' },
                {value: '5', label: 'quinta' },
                {value: '6', label: 'sexta'  },
                {value: '7', label: 'sabado' }
            ],
            opcoesSequencia: [
                {value: 0, label: 'nao'},
                {value: 1, label: 'sim'}
            ],
            opcoesAvulso: [
                {value: 0, label: 'nao'},
                {value: 1, label: 'sim'},
                {value: 2, label: 'com-contrassenha'}
            ],
            hourFormat: this.$t('hour-format'),
            innerDataInicio: null,
        }
    },
    created() {
        this.innerDataInicio = this.$moment(this.datainicio, 'YYYY-MM-DD').toDate();
    },
    methods: {
        searchColaborador(query) {
            this.colaboradoresLoading = true;

            this.colaboradorService.findListAssociated(query)
                .then(r => {
                    this.colaboradores = r.content.map(e => {
                        return {idusuario: e.id, nome: e.nome};
                    });
                })
                .catch(e => {
                    console.error("Erro ao pesquisar colaboradores.", e);
                })
                .finally(_ => {
                    this.colaboradoresLoading = false;
                });
        },
        handleTipoFrequenciaChange(novoTipo) {
            this.$emit('update:tipo-frequencia', novoTipo.value);

            if (novoTipo.value == 1) {
                // Atualiza para um valor de número de dias
                this.$emit('update:frequencia', '7');
            } else if (novoTipo.value == 2) {
                // Atualiza para dias da semana vazio
                this.$emit('update:frequencia', '');
            }
        },
        handleDiasSemanaChange(novosDias) {
            /*  Isso vai pegar o array de dias selecionados, que serão objetos
                do array diasSemana, e transformar nos valores separados por vírgula.

                Ex. Selecionou segunda, quarta e sexta, então 'novosDias' virá
                    [
                        {value: '2', label: 'segunda'},
                        {value: '4', label: 'quarta'},
                        {value: '6', label: 'sexta'}
                    ]
            */
            this.$emit(
                'update:frequencia', 
                novosDias
                    /* Ordena o array de objetos pela propriedade "value" */
                    .sort((a,b) => a.value.localeCompare(b.value))

                    /* Mapeia eles para retornar um array de strings, ex: ["2", "4", "6"] */
                    .map(e => e.value)

                    /* E cria a string dos elementos do array separado por vírgula; "2,4,6" */
                    .join(',')
            );
        },
        handleDateChange(newDate) { // objeto Date do javascript
            this.$emit('update:datainicio', this.$moment(newDate).format("YYYY-MM-DD"));
        },
        validateNumber(number) {
            let n = Number(number); // Vem como string

            if (isNaN(n)) {
                return 1;
            } else {
                return (n < 1) 
                    ? "1"
                    : (n > 365 ? "365" : n.toString());
            }
        }
    },
}
</script>

<style lang="scss" scoped>
@import "../../../../mixins.scss";

.column {
    @include default-size-column;
}

.page {
    position: relative;
    padding-left: 0;
        min-height: 100%;
        height: inherit;
        .calendar-btn {
            padding: 0;
            width: 100px;
            height: 35px;
        }
        .datepicker input{
            height: 40px !important;
        }
        .mt-3 {
            margin-top: 5rem !important;
        }
        .rodape-table-info{
            height: 100%;
        }
        .margin-none {
            margin: 0!important
        }
        .nav.nav-tabs {
            margin-bottom: 0;
            margin-left: -20px;
            padding-left: 20px;
        }
        .table-tag-full-width{
            width: 100%;
        }
    }
</style>